import React, { Component } from 'react'
import { Popover } from "antd";
import throttle from 'lodash/throttle';
import Icon from "@/components/Icon";
import styles from './devicePlanePosition.module.less'
import CONST from '@/dataSource/CONST'
import { downloadImg } from '@/utils/constant'

let IconWidth = 0;
let IconHeight = 0;
let Zoom = 1.0;
let InitZoom = 1.0;
class DevicePlanePosition extends Component {
    state = {
        datakey: 0,
        imageIsLoad: false,
        translateX: 0,
        translateY: 0,
    }
    imageIsMoving = false;
    lastX = null;
    lastY = null;
    componentDidMount() {
        const { imageUrl } = this.props;
        this.handleMouseMove = throttle(this.handleMouseMove, 30);
        this.refreshimage(imageUrl);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.imageUrl !== this.props.imageUrl) {
            this.refreshimage(this.props.imageUrl);
        }
    }

    refreshimage = (imageUrl) => {
        if (imageUrl && imageUrl.length > 0) {
            let imageInfo = new Image;
            imageInfo.src = imageUrl;
            imageInfo.onload = () => {
                this.ImageInfo = imageInfo;
                this.setImageWidth();
                this.setState({ imageIsLoad: true });
            };
        }
    }

    get imageWidth() {
        return this.ImageInfo ? this.ImageInfo.width * Zoom : 0;
    }

    get imageHeight() {
        return this.ImageInfo ? this.ImageInfo.height * Zoom : 0;
    }

    handleScroll = (e) => {
        const { imageIsLoad, translateX, translateY } = this.state;
        if (imageIsLoad) {
            let lastWidth = this.imageWidth;
            let lastHeight = this.imageHeight;
            if (e.nativeEvent.wheelDelta > 0) {
                if (this.imageWidth * 1.3 < 33554400/*Chrome浏览器最大滚动上限*/) {
                    Zoom *= 1.3;
                }
            } else {
                Zoom /= 1.3;
            }
            if (Zoom <= InitZoom) {
                this.setImageWidth();
            } else {
                let rect = e.currentTarget.getBoundingClientRect();
                let scaleWidth = (e.clientX - rect.left) / rect.width;
                let scaleHeight = (e.clientY - rect.top) / rect.height;
                let nowWidth = (this.imageWidth - lastWidth) * scaleWidth;
                let nowHeight = (this.imageHeight - lastHeight) * scaleHeight;
                this.state.translateX = translateX - nowWidth;
                this.state.translateY = translateY - nowHeight;
            }
            this.imageCheck();
            this.setState({ datakey: this.state.datakey + 1 });
        }
    }
    setImageWidth = () => {
        if (!(this.mainRect && this.ImageInfo)) return;
        let mainWidth = this.mainRect.width;
        let mainHeight = this.mainRect.height;
        let imageInfo = this.ImageInfo;
        if (mainWidth > 0 && mainHeight > 0) {
            if (mainWidth / mainHeight > imageInfo.width / imageInfo.height) {
                Zoom = mainHeight / imageInfo.height;
            }
            else {
                Zoom = mainWidth / imageInfo.width;
            }
            InitZoom = Zoom;
            this.setState({
                translateX: (mainWidth - this.imageWidth) / 2,
                translateY: (mainHeight - this.imageHeight) / 2,
                mainWidth, mainHeight
            })
        }
    }


    onMouseLeave() {
        this.imageIsMoving = false;
    }

    onMouseDown() {
        this.imageIsMoving = true;
    }

    onMouseUp() {
        this.imageIsMoving = false;
        this.lastX = null;
        this.lastY = null;
    }

    onMouseMove(e) {
        e.persist();
        e.stopPropagation();
        this.handleMouseMove(e);
    }

    handleMouseMove = (e) => {
        const { deviceList } = this.props;
        if (this.imageIsMoving) {
            if (this.lastX && this.lastY) {
                let dx = e.clientX - this.lastX;
                let dy = e.clientY - this.lastY;
                this.state.translateX = this.state.translateX + dx;
                this.state.translateY = this.state.translateY + dy;
                this.imageCheck();
                this.setState({ datakey: this.state.datakey + 1 });
            }
            this.lastX = e.clientX;
            this.lastY = e.clientY;
        } else {
            let selectDevices = deviceList.find(f1 => f1.isMouseDown);
            if (selectDevices) {
                this.onDeviceMouseMove(e, selectDevices);
            }
        }
    }

    imageCheck = () => {
        const { translateX, translateY } = this.state;
        let mainWidth = this.mainRect.width;
        let mainHeight = this.mainRect.height;
        let mainTop = this.mainRect.top;
        let mainLeft = this.mainRect.left;
        let x = translateX;
        let y = translateY;
        if (this.imageWidth > mainWidth && this.imageHeight > mainHeight) {
            if (translateX > 0)
                x = 0;
            if (translateY > 0)
                y = 0;
            if (translateX + this.imageWidth < mainWidth)
                x = mainWidth - this.imageWidth;
            if (translateY + this.imageHeight < mainHeight)
                y = mainHeight - this.imageHeight;
            this.setState({
                translateX: x,
                translateY: y,
            })
        }
        else if (mainWidth > this.imageWidth || mainHeight > this.imageHeight) {
            if (mainWidth > this.imageWidth) {
                let imageY = mainTop + translateY;
                if (translateY > 0) {
                    y = 0;
                }
                else if ((imageY + this.imageHeight) < (mainTop + mainHeight)) {
                    y = mainHeight - this.imageHeight;
                }
                this.setState({
                    translateX: (mainWidth - this.imageWidth) / 2,
                    translateY: y,
                })
            } else {
                let imageX = mainLeft + translateX;
                if (translateX > 0) {
                    x = 0;
                }
                else if ((imageX + this.imageWidth) < (mainLeft + mainWidth)) {
                    x = mainWidth - this.imageWidth;
                }
                this.setState({
                    translateX: x,
                    translateY: (mainHeight - this.imageHeight) / 2,
                })
            }
        }
    }

    onDeviceMouseDown(e, item) {
        const { deviceList } = this.props;
        e.stopPropagation();
        item.isMouseMove = false;
        item.isMouseClick = true;
        deviceList.map(f1 => {
            if (f1.deviceId === item.deviceId) {
                if (item.isMove)
                    item.isMouseDown = true;
            }
            else {
                f1.isMouseDown = false;
                f1.isMouseClick = false;
            }
        })
    }

    onDeviceMouseUp(item) {
        item.mouseDownX = null;
        item.mouseDownY = null;
        item.isMouseClick = false;
        item.isMouseDown = false;
        this.setState({ datakey: this.state.datakey + 1 });
    }

    onDeviceMouseMove(e, item) {
        e.stopPropagation();
        if (item.isMouseDown) {
            if (e.currentTarget && e.currentTarget.getBoundingClientRect) {
                let rect = e.currentTarget.getBoundingClientRect();

                let x = e.clientX - rect.left;
                if ((x - IconWidth / 2) < 0)
                    x = IconWidth / 2;
                if ((x + IconWidth / 2) > this.imageWidth)
                    x = this.imageWidth - IconWidth / 2;
                item.x = x / Zoom;

                let y = e.clientY - rect.top;
                if ((y - IconHeight / 2) < 0)
                    y = IconHeight / 2;
                if ((y + IconHeight / 2) > this.imageHeight)
                    y = this.imageHeight - IconHeight / 2;
                item.y = y / Zoom;

                item.isMouseMove = true;
                this.setState({ datakey: this.state.datakey + 1 });
            }
        }
    }

    showDevice = () => {
        const { deviceList, onCreate, onUpdata, onDelete } = this.props;
        return deviceList.map((item, index) => {
            let style = {
                position: `absolute`,
                left: `${item.x * Zoom - IconWidth / 2}px`,
                top: `${item.y * Zoom - IconHeight / 2}px`,
            }
            style.cursor = item.isMove ? "Move" : `Pointer`;
            if (item.isMove) {
                style.border = `0.03rem solid #1976D2`;
                style.borderRadius = 0;
            };
            let buttons = [];
            if (item.isMove && onCreate) {
                buttons.push(
                    <div className={styles.titleRow} onClick={() => onCreate && onCreate(item)}>
                        <Icon antd className={styles.icon} type="save" />
                        保存
                    </div>
                )
            }
            if (!item.isMove && onUpdata) {
                buttons.push(
                    <div className={styles.titleRow} onClick={() => onUpdata && onUpdata(item)}>
                        <Icon antd className={styles.icon} type="edit" />
                        修改
                    </div >
                )
            }

            if (onDelete) {
                buttons.push(
                    <div className={styles.titleRow} onClick={() => onDelete && onDelete(item)}>
                        <Icon antd className={styles.icon} type="delete" />
                        删除
                    </div >
                )
            }

            let content = (
                <React.Fragment>
                    {buttons}
                </React.Fragment>
            );
            let title = (
                <div className={styles.titlePopover}>
                    <span className={styles.text}>{`${item.name}`}</span>
                    <span className={styles.text}>{`${item.sn}`}</span>
                </div>
            );
            let deviceInfo = item.deviceInfo;
            return (
                <Popover
                    overlayClassName={styles.popover}
                    key={index}
                    content={content}
                    draggable={`false`}
                    trigger="contextMenu"
                    title={title}
                    placement="rightTop"
                >
                    <div
                        key={item.deviceId}
                        draggable={`false`}
                        className={styles.iconDiv}
                        title={`${item.name}(${item.sn})`}
                        ref={thisDiv => {
                            if (thisDiv && IconWidth <= 0) {
                                IconWidth = thisDiv.clientWidth;
                                IconHeight = thisDiv.clientHeight;
                                this.setState({ datakey: this.state.datakey + 1 });
                            }
                        }}
                        onMouseDown={e => this.onDeviceMouseDown(e, item)}
                        onMouseUp={() => this.onDeviceMouseUp(item)}
                        style={style}
                    >
                        <img
                            draggable={`false`}
                            title={`${item.name}(${item.sn})`}
                            className={styles.deviceImage}
                            src={downloadImg + deviceInfo[CONST.ProductIconByDeviceState[deviceInfo.deviceState]]}
                            alt={``}
                        />
                    </div>
                </Popover>
            )
        });

    }
    render() {
        const { imageIsLoad } = this.state;
        const { imageUrl } = this.props;
        return (
            <div
                className={styles.main}
                draggable={`false`}
                ref={thisDiv => {
                    if (thisDiv && !this.mainRect) {
                        this.mainRect = thisDiv.getBoundingClientRect();
                        this.setImageWidth();
                    }
                }}
            >
                <div
                    className={styles.imageDiv}
                    onWheel={e => this.handleScroll(e)}
                    onMouseDown={() => this.onMouseDown()}
                    onMouseUp={e => this.onMouseUp(e)}
                    onMouseMove={e => this.onMouseMove(e)}
                    onMouseLeave={() => this.onMouseLeave()}
                    draggable={`false`}
                    style={{
                        cursor: "move",
                        width: `${this.imageWidth}px`,
                        height: `${this.imageHeight}px`,
                        transform: `translateX(${this.state.translateX}px)translateY(${this.state.translateY}px)`,
                    }}
                >
                    {imageIsLoad ? (<img
                        className={styles.image}
                        src={imageUrl}
                        draggable={`false`}
                        style={{
                            position: `absolute`,
                            zIndex: `-1`,
                            width: `100%`,
                            height: `100%`,
                            border: `1px solid #1976D2`,
                        }}
                        alt=''
                    />) : ""}
                    {imageIsLoad ? this.showDevice() : ""}
                </div>
            </div>
        )
    }

}
export default DevicePlanePosition;
class DeviceInfo {
    constructor(device, position) {
        this.deviceInfo = device;
        this.id = position ? position.id : ``;
        this.sn = device ? device.sn : ``;
        this.name = device ? device.name : ``;
        this.deviceId = device ? device.id : ``;
        this.isMouseDown = false;
        this.isMouseClick = false;
        this.isMouseMove = false;
        this.isMove = false;
        this.icon = device ? device.productIcon : ``;
        this.x = position ? position.x : 100;
        this.y = position ? position.y : 100;
        this.mouseDownX = null;
        this.mouseDownY = null;
    }
}
export { DeviceInfo };
